import React from "react";

const COPYRIGHT_TEXT = "© 2026 VaultQuest. All rights reserved.";

export default function CopyrightFooter({ variant = "app" }) {
  const isLanding = variant === "landing";

  return (
    <footer
      aria-label="Copyright"
      style={{
        width: "100%",
        boxSizing: "border-box",
        padding: isLanding
          ? "0 calc(20px + var(--vq-safe-area-right)) calc(30px + var(--vq-safe-area-bottom)) calc(20px + var(--vq-safe-area-left))"
          : "4px calc(16px + var(--vq-safe-area-right)) 0 calc(16px + var(--vq-safe-area-left))",
        margin: isLanding ? "0 auto" : "24px auto 0",
        textAlign: "center",
        color: "rgba(255,255,255,0.54)",
        fontSize: 12,
        lineHeight: 1.4,
        fontWeight: 700,
        letterSpacing: 0.2,
      }}
    >
      {COPYRIGHT_TEXT}
    </footer>
  );
}
